import axios from "axios";
import {
  REQUEST_VERIFY_TOKEN,
  REQUEST_VERIFY_TOKEN_SUCCESS,
  REQUEST_VERIFY_TOKEN_FAILED,
  VERIFY_USER,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILED
} from "./types";
import bugsnag from "@bugsnag/js";
import { SSO_URL } from "../../config/environment";
import { getCookie, setStorage } from "../../utils/helpers";
import { signOutUser } from "../auth/actions";
import { notification } from "antd";
import cw from "../../utils/commonwords";
const bugsnagClient = bugsnag("ab84c0b67d6464d40ea9bc8050d778e7");

export const requestVerificationCode = (
  userId,
  intl,
  siteLanguage,
  type,
  email,
  phoneNubmer
) => {
  return dispatch => {
    dispatch({ type: REQUEST_VERIFY_TOKEN });
    axios({
      method: "POST",
      url: `${SSO_URL}/auths/verify`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`
      },
      data: {
        email,
        verifyBy: type === "email" ? email : phoneNubmer
      }
    })
      .then(response => {
        if (response.data.statusCode === 200) {
          dispatch({ type: REQUEST_VERIFY_TOKEN_SUCCESS });
        } else if (
          response.data.statusCode === 498 ||
          response.data.statusCode === 401
        ) {
          signOutUser(userId, intl, siteLanguage);
        } else {
          dispatch({ type: REQUEST_VERIFY_TOKEN_FAILED });
          notification.warning({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw.verifyTokenRequstFailed)
          });
        }
      })
      .catch(err => {
        dispatch({ type: REQUEST_VERIFY_TOKEN_FAILED });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.verifyTokenRequstFailed)
        });
        bugsnagClient.notify(err);
      });
  };
};
export const verifyVerificationCode = (code, intl, siteLanguage) => {
  return dispatch => {
    dispatch({ type: VERIFY_USER });
    axios({
      method: "GET",
      url: `${SSO_URL}/auths/verify?verifyCode=${code}`,
      headers: {
        Accept: "application/json",
        "x-access-token": `${getCookie("user_token")}`
      }
    })
      .then(response => {
        if (response.data.statusCode === 200) {
          notification.success({
            message: "Success",
            description: intl.formatMessage(cw.verifiedSuccess)
          });
          setStorage(
            "esoko_user",
            JSON.stringify(response.data.data)
          );
          dispatch({ type: VERIFY_USER_SUCCESS, payload: response.data });
          //   setTimeout(() => {
          //     window.location.assign(
          //       window.location.origin + window.location.pathname
          //     );
          //   }, 2000);
        } else if (
          response.data.statusCode === 498 ||
          response.data.statusCode === 401
        ) {
          signOutUser(intl, siteLanguage);
        } else {
          dispatch({ type: VERIFY_USER_FAILED });
          notification.warning({
            message: intl.formatMessage(cw.Failed),
            description: intl.formatMessage(cw.verifiedFailed)
          });
        }
      })
      .catch(err => {
        dispatch({ type: VERIFY_USER_FAILED });
        notification.error({
          message: intl.formatMessage(cw.Failed),
          description: intl.formatMessage(cw.verifiedFailed)
        });
        bugsnagClient.notify(err);
      });
  };
};
